import { AxiosResponse } from 'axios';
import { KeyValue } from '@/main/models/common';
import {
  SaveSupplierConfigurationRequest,
  SupplierFavoriteRequest,
  SupplierFilterRequest,
  SupplierSaveRequest,
  ChangeSupplierRelationInfoRequest
} from '@/main/models/request/supplierRequest';
import {
  SupplierAssignBodyshopResponse,
  SupplierRegistrationDataResponse,
  SupplierResponse
} from '@/main/models/response';
import { Result } from '@/main/models/common/resultResponse';
import { SupplierCompanyRelationFilterRequest } from '@/main/models/request/supplierCompanyRelationRequest';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { SupplierCompanyRelationResponse } from '@/main/models/response/supplierCompanyRelationResponse';
import { PartTypeSupplierIgnoreRequest } from '@/main/models/request/partTypeSupplierIgnoreRequest';
import { PartTypeSupplierIgnoreResponse } from '@/main/models/response/partTypeSupplierIgnoreResponse';

export abstract class ISupplierApi {
  abstract getFavoriteSuppliersByCompanyBuyer(
    request: SupplierFavoriteRequest
  ): Promise<AxiosResponse<PaginationResponse<KeyValue[]>>>;
  abstract getSuppliersOrSupplierBranchesDomain(
    request: SupplierFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getSearchGrid(
    request: SupplierFilterRequest
  ): Promise<AxiosResponse<SupplierResponse>>;

  abstract saveSupplier(
    request: SupplierSaveRequest
  ): Promise<AxiosResponse<Result<any>>>;

  abstract getSupplierData(
    request: SupplierFilterRequest
  ): Promise<AxiosResponse<Result<SupplierRegistrationDataResponse>>>;

  abstract getGridRestrictedAndFavorite(
    request: SupplierFilterRequest
  ): Promise<
    AxiosResponse<PaginationResponse<SupplierRegistrationDataResponse>>
  >;

  abstract getSupplierRestrictedAndFavorite(
    request: SupplierCompanyRelationFilterRequest
  ): Promise<
    AxiosResponse<PaginationResponse<SupplierCompanyRelationResponse>>
  >;

  abstract saveSupplierConfiguration(
    request: SaveSupplierConfigurationRequest
  ): Promise<AxiosResponse<Result<void>>>;

  abstract getBodyshopByRFC(
    RegistrationNumber: string,
    guidCountry: string
  ): Promise<AxiosResponse<Result<SupplierAssignBodyshopResponse[]>>>;

  abstract getFavoriteSuppliersByQuoteItem(
    guidQuoteItem: string
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract changeSupplierRelationInfo(
    guidSupplierCompanyRelation: string,
    request: ChangeSupplierRelationInfoRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getPartTypeSupplierIgnore(
    request: PartTypeSupplierIgnoreRequest
  ): Promise<AxiosResponse<Result<PartTypeSupplierIgnoreResponse[]>>>;
}
